


































































import ReviewListPaginatedForSimulation from '@/components/ReviewListPaginatedForSimulation'
import DropDownSearch from '@/components/DropDownSearch'
import gql from '@/gqlService.coffee'
import utils from '@/utils.coffee'
import queries from "@/gql/queries.coffee"
import 'bulma-switch';


export default {
    "name": 'ReviewListFilterFlowSimulation',
    "components":{ReviewListPaginatedForSimulation, DropDownSearch}
    "props": {}
    "computed":
        "style": ()->
            return {
                height: this.height
            }
        "filters": ()->
            return {
                status:
                    this.status
                sentiment:
                    this.sentiment
                classified:
                    this.classified 
                late:
                    this.late
                platform:
                    this.platform
                establishment:
                    this.establishment
                consultant:
                    this.consultant
                search_string:
                    this.search_string
                dateBeginFilter:
                    this.dateBegin
                dateEndFilter:
                    this.dateEnd
                tag:
                    this.tag
                has_game_filter:
                    this.has_game_filter
            }
    "data": ()->
        return {
            "dateBegin": null
            "dateEnd": null
            "has_game_filter": false
            "status_set": null
            "tag": {name:null}
            "tag_set": [
                    {name: 'Supprimé', code: 'deleted'},
                    {name: 'Répondu', code: 'answered'},
                    {name: 'Impossible', code: 'Impossible'}
            ]
            "status": {"name": null, "uid": null}
            "sentiments": [
                {"name": "Positif", "value": true},
                {"name": "Négatif", "value": false}
            ]
            "sentiment": {"name": null, "value": null}
            "classified": false
            "height": (window.innerHeight-30)+ "px"
            "listHeight": (window.innerHeight-260)+ "px"
            "late":false
            "search_string": ""
            "platform": {"name": null}
            "platforms": gql.query({
                "model": "platform_set"
                "fields": "uid name"
            })
            "establishment": {"name": null}
            "establishments": gql.query({
                "model": "establishment_set"
                "fields": "uid name"
                "filters": "active: true"
            })
            "consultant": {"lastname": null}
            "consultants": gql.query({
                "model": "consultant_set"
                "fields": "uid lastname firstname fullname"
            })
        }
    "methods":
        "select_review": (uid)->
            @$emit('select_review', uid)
        "tagClicked": (item)->
            #console.log("item", item)
            @tag = item or {name: null}
        "dateBeginClicked": (item)->
            #console.log("item", item)            
        "dateEndClicked": (item)->
            #console.log("item", item)
        "sentimentClicked": (item)->
            @sentiment = item or {"name": null, "value": null}
        "platformClicked": (item)->
            @platform = item or {"name": null}
        "establishmentClicked": (item)->
            console.log("establishmentClicked", item)
            @establishment = item or {"name": null}
            console.log("establishmentClicked", @establishment)
        "consultantClicked": (item)->
            @consultant = item or {"lastname": null}
        "stateClicked": (item)->
            @status = item or {"name": null, "value": null}
            @classified = (@status.value == "Classified")
        "setHeight": utils.debounce(
            ()->
                @height = (window.innerHeight-30)+ "px"
                @listHeight = (window.innerHeight-260)+ "px" 
                return
            , 500)
    "mounted": ()->
        vm = this
        vm.setHeight()
        window.addEventListener('resize', this.setHeight)
        data = await queries.run("named_state_set")
        vm.status_set = data.body.data.named_state_set
    "beforeDestroy": ()->
        window.addEventListener('resize', this.setHeight)
            

}
